export const DynamicComponents = (props)  => {
    const obj=props.object;
    const property=props.property;
    if (!obj) return;
    if (!obj[property]) return;
    const componentArray = obj[property];
    return (
  <>
    {componentArray!=null && componentArray.map( componentObj => (
        <componentObj.Component {...componentObj.props}/>
    ))}
    </>
  
    )
    
  }